import React from 'react';
import {Text} from 'ui-kits';

type ProgressCircleProps = Readonly<{
  progressPercentage: number;
  size?: number;
  strokeWidth?: number;
}>;

export default function ProgressCircle(props: ProgressCircleProps) {
  const {progressPercentage, size = 100, strokeWidth = 80} = props;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const filledPortion =
    circumference - (progressPercentage / 100) * circumference;

  return (
    <div style={{position: 'relative', display: 'inline-block'}}>
      <svg width={size} height={size}>
        <defs>
          <linearGradient
            id="progressGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%">
            <stop offset="70%" stopColor="#7366ff" /> {/* blue at 70% */}
            <stop offset="100%" stopColor="#FF6CAB" /> {/* pink at 100% */}
          </linearGradient>
        </defs>
        {/* Background Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#DFDDF5"
          strokeWidth={strokeWidth}
          fill="none"
        />
        {/* Progress Circle */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="url(#progressGradient)"
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={filledPortion}
          strokeLinecap="round"
          fill="none"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      {/* Progress Text */}
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}>
        <Text id="percentageText">{progressPercentage}%</Text>
        <Text id="completedText">Completed</Text>
      </div>
    </div>
  );
}
